import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';

export const MessengerMediaPreviewModal = ({
  open,
  onClose,
  title,
  children,
  dataTestId,
}) => (
  <AnimatePresence>
    {open ? (
      <motion.div
        key="media-preview-overlay"
        data-testid={dataTestId}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 12000,
          background: 'rgba(10, 10, 18, 0.64)',
          backdropFilter: 'blur(10px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 18px',
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.94, y: 14 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.94, y: 14 }}
          transition={{ duration: 0.22, ease: 'easeOut' }}
          onClick={(event) => event.stopPropagation()}
          className="premium-card"
          style={{
            width: '100%',
            maxWidth: 348,
            padding: '16px 16px 18px',
            borderRadius: 30,
            background: 'var(--surface)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 12 }}>
            <p style={{ margin: 0, fontFamily: "'Inria Serif', serif", fontSize: 20, fontWeight: 700, color: 'var(--text)' }}>{title}</p>
            <button
              type="button"
              data-testid={`${dataTestId}-close-button`}
              onClick={onClose}
              style={{
                width: 38,
                height: 38,
                borderRadius: '50%',
                border: '1px solid var(--card-border)',
                background: 'var(--surface)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <X size={18} color="var(--accent-text-soft)" />
            </button>
          </div>
          {children}
        </motion.div>
      </motion.div>
    ) : null}
  </AnimatePresence>
);